import { useMantineTheme } from '@mantine/core';
import type { SecodaAIProposalOut } from '@repo/api-codegen';
import { IconEmoji } from '@repo/common/components/IconEmoji/IconEmoji';
import type { IBaseModel } from '@repo/common/models/baseModel';
import { useMemo, type MouseEvent } from 'react';
import type { DocumentCreationProposalData } from './DocumentSuggestionRenderer';
import { SuggestionItemTable } from './SuggestionItemTable';

type DocumentSuggestionWithBaseModel = DocumentCreationProposalData &
	IBaseModel;

export interface DocumentSuggestionTableProps {
	suggestions: {
		proposal: SecodaAIProposalOut;
		data: DocumentCreationProposalData;
	}[];
	onRowClick: (
		row: DocumentCreationProposalData & IBaseModel,
		index: number,
		event: MouseEvent
	) => void;
}

export function DocumentSuggestionTable({
	suggestions,
	onRowClick,
}: DocumentSuggestionTableProps) {
	const theme = useMantineTheme();
	const records = useMemo(
		() =>
			suggestions.map((suggestion) => ({
				...suggestion.data,
				id: suggestion.proposal.id,
				created_at: suggestion.proposal.created_at,
				updated_at: suggestion.proposal.updated_at,
			})),
		[suggestions]
	);

	return (
		<SuggestionItemTable<DocumentSuggestionWithBaseModel>
			items={records}
			iconRenderer={(item) => (
				<IconEmoji
					value={item.icon || 'iconName:file'}
					size={theme.other.typography.text.md}
				/>
			)}
			titleSelector={(item) => item.title}
			subTextSelector={() => 'Create document'}
			onItemClick={onRowClick}
		/>
	);
}
